import { render, staticRenderFns } from "./CustomerBookingList.vue?vue&type=template&id=6b4acc30&"
import script from "./CustomerBookingList.vue?vue&type=script&lang=js&"
export * from "./CustomerBookingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports